import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, Transition as _Transition, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pr-2 sm:hidden" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "selected-tab",
  class: "sr-only"
}, "Select a tab", -1)
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "hidden sm:block" }
const _hoisted_5 = { class: "border-b border-gray-200" }
const _hoisted_6 = { class: "-mb-px flex space-x-8" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "font-medium capitalize" }
const _hoisted_9 = { class: "py-1" }
const _hoisted_10 = { class: "py-1" }
const _hoisted_11 = { class: "py-1" }
const _hoisted_12 = {
  key: 1,
  class: "relative"
}
const _hoisted_13 = {
  key: 0,
  style: {"background":"linear-gradient(90deg, #ff9d00 0%, #ff4000 100%)","font-size":"8px"},
  class: "absolute px-1.5 -mt-0.5 rounded-full text-white font-medium -top-4 -right-8"
}

import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ChevronDownIcon } from "@heroicons/vue/24/solid";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import {
  useRoute,
  useRouter,
  RouteLocationAsRelativeGeneric,
  RouteLocationAsPathGeneric,
} from "vue-router";
import { useHasPermission } from "shared/composables/project";
import "@/assets/styles/skeleton.css";
import { useCurrentProject } from "@/composables/project";

type CameraTab = {
  name: string;
  route: RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CameraNavbar',
  props: {
  initialActiveTag: String,
  stream: Object,
},
  setup(__props) {

const router = useRouter(); // Initialize `useRouter`

// Define props
const props = __props;

const tabs = ref<CameraTab[]>();
const collapsedTabs = ref<CameraTab[]>();

const { t } = useI18n();
const currentProjectV2 = useCurrentProject();
const hasAllCameraPermission = useHasPermission("all_camera_features_user");
const hasProcessesPermission = useHasPermission("processes_user");

onMounted(() => {
  const projectStatus = currentProjectV2.status;
  let newTabs = [];
  let newCollapsedTabs = [];

  if (hasAllCameraPermission) {
    newTabs = [
      { name: "live", route: { name: "Live" } },
      { name: "period", route: { name: "Period" } },
      { name: "gallery", route: { name: "Gallery" } },
      { name: "compare", route: { name: "Compare" } },
      { name: "timelapse", route: "#" },
    ];

    newCollapsedTabs = [
      { name: "live", route: { name: "Live" } },
      { name: "period", route: { name: "Period" } },
      { name: "gallery", route: { name: "Gallery" } },
      { name: "compare", route: { name: "Compare" } },
      { name: "daily_timelapse", route: { name: "DailyTimelapse" } },
      { name: "customizable_timelapse", route: { name: "CustomizableTimelapse" } },
      { name: "project_timelapse", route: { name: "ProjectTimelapse" } },
    ];

    if (!props.stream?.aws_stream_id) {
      newTabs.splice(0, 2);
      newCollapsedTabs.splice(0, 2);
    }
  } else if (projectStatus === "active") {
    newTabs = [{ name: t("app_features.live"), route: { name: "Live" } }];
    newCollapsedTabs = [{ name: t("app_features.live"), route: { name: "Live" } }];
  } else {
    newTabs = [
      {
        name: t("app_features.project_timelapse"),
        route: { name: "ProjectTimelapse" },
      },
    ];
    newCollapsedTabs = [
      { name: t("app_features.project_timelapse"), route: { name: "ProjectTimelapse" } },
    ];
  }

  // Update `tabs` and `collapsedTabs`
  tabs.value = newTabs.map((tab) => ({
    ...tab,
    route: typeof tab.route === "string" ? { name: tab.route } : tab.route,
  })) as CameraTab[];
  collapsedTabs.value = newCollapsedTabs;
});

// Set activeTab as a ref of the selected tab
const activeTab = ref<CameraTab>();
const route = useRoute();

onMounted(() => {
  activeTab.value = collapsedTabs.value?.find((item) => {
    return item.route && "name" in item.route && item.route.name === route.name;
  });
});

const onSelectChange = () => {
  if (activeTab?.value?.route) {
    router.push(activeTab.value.route);
  }
};

const isCurrentTab = (tab: CameraTab) => {
  if ("name" in tab.route) {
    return route.name === tab?.route?.name;
  }
  return false;
};

const isTimelapseCurrent = () => {
  if (route && typeof route.name === "string") {
    return ["DailyTimelapse", "CustomizableTimelapse", "ProjectTimelapse"].includes(route.name);
  }
  return false; // Return false if route is not valid or name is not a string
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("select", {
        id: "selected-tab",
        name: "selected-tab",
        class: "focus:outline-none mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 focus:border-yellow-500 focus:ring-yellow-500 text-sm",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
        onChange: onSelectChange
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collapsedTabs.value, (tab) => {
          return (_openBlock(), _createElementBlock("option", {
            key: tab?.name,
            value: tab,
            class: "capitalize"
          }, _toDisplayString(_ctx.$t(`app_features.${tab.name}`)), 9, _hoisted_3))
        }), 128))
      ], 544), [
        [_vModelSelect, activeTab.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("nav", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tab?.name,
              class: _normalizeClass([
            isCurrentTab(tab) || (tab.name === 'timelapse' && _unref(route)?.name && isTimelapseCurrent())
              ? 'border-yellow-500 text-yellow-600'
              : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
            'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium',
          ])
            }, [
              (tab.name === 'timelapse')
                ? (_openBlock(), _createElementBlock("a", _hoisted_7, [
                    _createVNode(_unref(Menu), {
                      as: "div",
                      class: "relative z-20 inline-block text-left"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_unref(MenuButton), { class: "inline-flex" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(`app_features.${tab.name}`)), 1),
                              _createVNode(_unref(ChevronDownIcon), {
                                class: "-mr-1 ml-2 h-5 w-5",
                                "aria-hidden": "true"
                              })
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createVNode(_Transition, {
                          "enter-active-class": "transition ease-out duration-100",
                          "enter-from-class": "transform opacity-0 scale-95",
                          "enter-to-class": "transform opacity-100 scale-100",
                          "leave-active-class": "transition ease-in duration-75",
                          "leave-from-class": "transform opacity-100 scale-100",
                          "leave-to-class": "transform opacity-0 scale-95"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(MenuItems), { class: "left-mt-2 focus:outline-none absolute w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-2 ring-gray/5" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_unref(MenuItem), null, {
                                    default: _withCtx(({ active }) => [
                                      _createVNode(_component_router_link, {
                                        to: { name: 'DailyTimelapse' },
                                        class: _normalizeClass([
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'block px-4 py-2 text-sm',
                        ])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("app_features.daily_timelapse")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                  _createVNode(_unref(MenuItem), null, {
                                    default: _withCtx(({ active }) => [
                                      _createVNode(_component_router_link, {
                                        to: { name: 'CustomizableTimelapse' },
                                        class: _normalizeClass([
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'block px-4 py-2 text-sm',
                        ])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("app_features.customizable_timelapse")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                  _createVNode(_unref(MenuItem), null, {
                                    default: _withCtx(({ active }) => [
                                      _createVNode(_component_router_link, {
                                        to: { name: 'ProjectTimelapse' },
                                        class: _normalizeClass([
                          active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                          'block px-4 py-2 text-sm',
                        ])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("app_features.project_timelapse")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      to: tab.route
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`app_features.${tab.name}`)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    (tab.name === 'compare' && _unref(hasProcessesPermission))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t("camera.compare.sections")), 1))
                      : _createCommentVNode("", true)
                  ]))
            ], 2))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})